import { render, staticRenderFns } from "./announce_conc.vue?vue&type=template&id=0d30aab2&scoped=true"
import script from "./announce_conc.vue?vue&type=script&lang=js"
export * from "./announce_conc.vue?vue&type=script&lang=js"
import style0 from "./announce_conc.vue?vue&type=style&index=0&id=0d30aab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d30aab2",
  null
  
)

export default component.exports